import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NdtHubBase } from '../base/ndt-hub.base';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';
import { extensionPhoneDndChanged, extensionPhoneForwardCallsChanged } from './extension-phone-hub.actions';

@Injectable({ providedIn: 'root' })
export class ExtensionPhoneHubService extends NdtHubBase {
   constructor(public ndtHubService: NdtHubConnectionService, private store: Store) {
      super(ndtHubService);
   }

   registerExtensionPhoneEvents(accountId: number | null): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('JoinExtensionPhoneDndGroup', accountId);
      });
   }
   
   registerExtensionPhoneForwardCallsEvents(accountId: number | null): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('JoinExtensionPhoneForwardCallsGroup', accountId);
      });
   }

   wireUpHubEvents(): void {
      this.ndtHubService.connection.on('ExtensionPhoneDndChanged', (data: any) => {
         this.store.dispatch(
            extensionPhoneDndChanged({
               extensionPhoneId: data.extensionPhoneId,
               dndStatus: data.dndStatus,
            })
         );
      });
      this.ndtHubService.connection.on('ExtensionPhoneForwardCallsChanged', (data: any) => {
         this.store.dispatch(
            extensionPhoneForwardCallsChanged({
               extensionPhoneId: data.extensionPhoneId,
               forwardExtensionId: data.forwardExtensionId,
               forwardExternalNumber: data.forwardExternalNumber,
            })
         );
      });
   }
}